























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../main";
import CreateDialog from "./Dialogs/CreateDialog.vue";
import * as data from "../_store/data.module";
import { readUserInfo } from "../_store/user.module";
import DocSignDialog from "./Dialogs/DocSignDialog.vue";
import DetailsDialog from "./Dialogs/DetailsDialog.vue";

@Component({
  components: {
    CreateDialog,
    DocSignDialog,
    DetailsDialog
  }
})
export default class ReportVisite extends Vue {
  @Prop() params!: any;
  @Prop() createReportDialogParams!: any;
  @Prop() idRichiesta!: number;
  @Prop() infoTirocinio!: any;
  private dialog: boolean;
  private search: string;
  private reportRecords: any;
  private loadingData: boolean;

  constructor() {
    super();
    this.dialog = false;
    this.search = "";
    this.reportRecords = this.params.records;
    this.loadingData = true;
  }

//   close() {
//     this.dialog = false;
//     bus.$emit("destroyReportDialog");
//   }

  loadReports() {
    var infoReport = {
      idRichiesta: this.idRichiesta,
      attivita: this.params.activityType
    };
    data
      .dispatchReportVisite(this["$store"], infoReport)
      .then(result => {
        this.reportRecords = result;
        this.loadingData = false;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
  created() {
    this.loadReports();

    bus.$on("reportDataLoaded", () => {
      this.loadingData = false;
    });

    bus.$on("loadReports", () => {
      this.loadReports();
    });
  }
}
